export default __webpack_public_path__ + "static/media/kitchen3-afterE-768w.a183de12.webp";